import ajax from '../../lib/ajax';
import { transformerData } from '../transformer/index';
function fetch(config) {
    if(config.request&&config.request.id){
        return ajax.get(`/api/table/${config.request.id}`).then(data=>{
            if(Error.isError(data)){
                throw data
            }else{
                let v = JSON.parse(data.result.data);
                if(config.transformers&&config.transformers.length){
                    return transformerData(v, config.transformers);
                }else{
                    return v;
                }
            }
        })
    }else{
        return Promise.resolve(config);
    }
}

function createOrUpdate(data, config) {
    if(config&&config.id){
        return remove(config).then(()=>{
            return create(data)
        })
    }else if(data){
        return create(data);
    }
}

function create(data) {
    return ajax.post(`/api/table/`, {data:data, name:''+Math.random()}).then(resp=>{
        return resp.result;
    });
}

function remove(config){
    if(config&&config.id){
        return ajax.delete(`/api/table/${config.id}`).then(data=>{
            if(Error.isError(data)){
                throw data
            }else{
                return data.result;
            }
        })
    }else{
        return Promise.resolve();
    }
}

export {fetch, createOrUpdate}